export const Marks = ( {data, x, y, r, color, onMouseEnter, onMouseLeave, hoveredLipid, onClick}) => (
  data.map(d => {
    const extra = hoveredLipid === d.lipid ? 'active' : "inactive";
    return (
      <circle 
        key={d.lipid}
        id={d.lipid}
        className={"dots " + extra}
        cx={x(d.cc)}
        cy={y(d.db)} 
        r={r(d.probability)}
        fill={color(d.cc)}
        stroke='black'
        opacity={0.9}
        onMouseEnter={e => onMouseEnter(e, d)}
        onMouseLeave={onMouseLeave}
        onClick={onClick}
      />
    )
  })
);


